import { A, useNavigate, useSearchParams } from "@solidjs/router";
import { createResource, createSignal, createMemo, For, Show, createEffect } from "solid-js";

import { getCustomerInvoices } from "~/_server/accounts";
//import { getByUser } from "~/_server/dynamoDB";

import { Paginator, Download } from "~/components";
import { useRIASApp } from "~/_context/UserProvider";

export const Invoices = ( props ) => {
	const navigate = useNavigate();
	const app = useRIASApp();

	const [searchParams] = useSearchParams();

	const [page, setPage] = createSignal( 0 );
	const [pageSize, setPageSize] = createSignal( 10 );

	const [invoices, { refetch: refetchInvoices }] = createResource( async () => props.email ? await getCustomerInvoices( props.email.trim() ) : null );

	const [noResult, setNoResult] = createSignal( false );

	createEffect( () => {
		if ( invoices() && invoices()?.length == 1 && invoices()?.[0].error ) {
			setNoResult( true );
		}
	} );

	createEffect( () => {
		if ( searchParams?.paymentMade == 'true' ) {
			refetchInvoices();
		}
	} );

	const pagedInvoices = createMemo( () => {
		if ( !invoices() ) return [];

		const start = page() * pageSize();

		return invoices()?.slice( start, start + pageSize() )
	} );

	return (
		<div class="space-y-4">
			<Show when={pagedInvoices()?.length}>
				<ul class="divide-y border rounded bg-white shadow">
					<Show when={noResult()}>
						<li class="p-4 flex justify-between items-center">A lists of invoices is not currently available. Please try later.</li>
					</Show>

					<Show when={pagedInvoices()?.length == 0}>
						<li class="p-4 flex justify-between items-center">No invoices have been issued to your account.</li>
					</Show>

					<For each={pagedInvoices()}>
						{( invoice: any ) => {
							const isPending = false;// pendingInvoices()?.items.some( pi => pi.sk === `INVOICE#${invoice.invoiceID}` );

							return	(
								<li class="p-4 flex justify-between items-center">
									<Show when={invoice?.error}>
										<p class="text-sm text-gray-600">
											{invoice.error}
										</p>
									</Show>

									<Show when={!invoice.error}>
										<p class="text-sm text-gray-600">
											{invoice.date?.slice( 0, 10 )}
										</p>
										<p class="font-medium">{invoice.invoiceNumber}</p>

										<p class="text-sm text-gray-600">
											£{invoice.total?.toFixed( 2 )}
										</p>

										<p class="text-sm text-gray-600">
											<Show when={invoice.status === 'PAID'}>
												<span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20">PAID</span>
											</Show>

											<Show when={invoice.status === 'VOIDED'}>
												<span class="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/20">VOID</span>
											</Show>
											
											<Show when={isPending}>
												<span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-700 inset-ring inset-ring-yellow-600/20">Processing Payment</span>
											</Show>
											
											<Show when={!isPending && invoice.status !== 'PAID' && invoice.amountDue > 0}>
												<button type="button" class="rounded-sm bg-sky-600 px-2 py-1 text-xs font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
													onClick={() => navigate( `?invoiceId=${invoice.invoiceId}&invoiceNumber=${invoice.invoiceNumber}&amount=${invoice.amountDue}`, { replace: false, scroll: false } )}>Pay Now</button>
											</Show>

											{/* For testing purposes only - to set the pending marker without making a payment 
											<button type="button" class="rounded-sm bg-red-600 px-2 py-1 text-xs" onClick={async () => await setInvoicePending( app.sessionId(), invoice.invoiceID )}>Set marker</button>
											*/}
										</p>

										<div class="space-x-4 fill-amber-600">
											<A
												class="text-primary hover:underline hover:text-amber-600"
												href={`/api/accounting/invoice-pdf/${invoice.invoiceId}`}
												target="_blank"
												title="Download invoice"
											>
												<Download />
											</A>
										</div>
									</Show>
								</li>
							);
						}}
					</For>

				</ul>
			</Show>

			<Show when={invoices.loading || invoices() && invoices()?.length > pageSize()}>
				<Paginator page={page()}
					setPage={setPage}
					pageSize={pageSize()}
					total={invoices()?.length ?? 0}
					itemName="invoices" />
			</Show>
		</div>
	);
}


export default Invoices;